<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4.5H3.33333H14"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6667 4.49992V13.8333C12.6667 14.1869 12.5262 14.526 12.2762 14.7761C12.0261 15.0261 11.687 15.1666 11.3334 15.1666H4.66671C4.31309 15.1666 3.97395 15.0261 3.7239 14.7761C3.47385 14.526 3.33337 14.1869 3.33337 13.8333V4.49992M5.33337 4.49992V3.16659C5.33337 2.81296 5.47385 2.47382 5.7239 2.22378C5.97395 1.97373 6.31309 1.83325 6.66671 1.83325H9.33337C9.687 1.83325 10.0261 1.97373 10.2762 2.22378C10.5262 2.47382 10.6667 2.81296 10.6667 3.16659V4.49992"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33337 7.83325V11.8333"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66663 7.83325V11.8333"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
